import { compressToUTF16, decompressFromUTF16 } from 'lz-string';
import { Injectable } from '@angular/core';
import { isCountryPE, replacer } from 'src/app/common/util/util';
import {
  getForm,
  reloadform,
  reloadProductJSON,
} from 'src/app/multi_product/policy/generic-input/inputs-names-utils';


@Injectable({ providedIn: 'root' })
export class LocalStorageService {


  private prepareValue(value: any, withCompression: boolean, isReplacer: boolean): string {
    if (value === undefined) return null;
    const stringValue = isReplacer ? JSON.stringify(value, replacer) : JSON.stringify(value);
    return withCompression ? compressToUTF16(stringValue) : stringValue;
  }

  set(key: string, value: any, withCompression = false, isReplacer = false): void {
    const validValue = this.prepareValue(value, withCompression, isReplacer);
    if (validValue !== null) {
      localStorage.setItem(key, validValue);
    }
    if (key === 'productJSON') {
      reloadProductJSON();
    }
    if (key === 'form') {
      reloadform();
    }
  }

  setWithExpiry(
    key: string,
    value: any,
    country: string,
    ttl: number,
    withCompression = false
  ): void {
    const now = Date.now();
    const item = { value, expiry: now + ttl };
    const stringValue = JSON.stringify(item);
    const finalValue = withCompression ? compressToUTF16(stringValue) : stringValue;
    localStorage.setItem(`${country}_${key}`, finalValue);
  }

  getWithExpiry(key: string, country: string, withCompression = false): any {
    const fullKey = `${country}_${key}`;
    const item = this.get(fullKey, withCompression) || this.get(key, withCompression);
    if (!item || !item.expiry) return null;

    const now = Date.now();
    if (now > item.expiry) {
      localStorage.removeItem(fullKey);
      localStorage.removeItem(key);
      return null;
    }

    return item.value;
  }

  get(key: string, withCompression: boolean = false): any {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    const data = withCompression ? decompressFromUTF16(raw) : raw;
    try {
      return JSON.parse(data);
    } catch {
      return data;
    }
  }

  getStepOne(): any {
    const form = isCountryPE() ? getForm() : this.get('form');
    if (!Array.isArray(form)) return null;
    return form.find((item) => item.step === 1) || form[0];
  }

  getStepTwo(): any {
    const form = this.get('form');
    if (!Array.isArray(form)) return null;
    return form.find(item => item.step === 2) || form[1];
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
